import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import AddonCard from 'products/nomad_insurance/components/AddonCard';
import { NI_ADDONS } from 'products/nomad_insurance/constants';
import { Items } from './styled';
import { SubTitle } from '../../../../styled';

const Addons = ({
  showUSAddon = true,
  numberOfDays,
  selectedAddons,
  onAddonChange,
  isFixed
}) => {
  const dispatch = useDispatch();

  const isLessThanMonth = numberOfDays < 28;
  const isRecurringAddonsAllowed = !isFixed || numberOfDays >= 364;

  const isItemInsurance = (name) => name === NI_ADDONS.ITEM_INSURANCE.value;
  const isSportsInsurance = (name) => name === NI_ADDONS.SPORTS_COVERAGE.value;
  const isUSAddon = (name) => name === NI_ADDONS.USA_COVERAGE.value;

  const addonsToShow = useMemo(() => {
    let addons = Object.values(NI_ADDONS);

    if (!showUSAddon) {
      addons = addons.filter((addon) => !isUSAddon(addon.value));
    }
    return addons;
  }, [numberOfDays, showUSAddon]);

  useEffect(() => {
    // De-select item insurance for fixed policy
    const itemInsurance = selectedAddons.find((x) => isItemInsurance(x.value));
    if (!isRecurringAddonsAllowed && itemInsurance) {
      onAddonChange(itemInsurance);
    }

    // De-select sports insurance for fixed policy
    const sportsInsurance = selectedAddons.find((x) => isSportsInsurance(x.value));
    if (!isRecurringAddonsAllowed && sportsInsurance) {
      onAddonChange(sportsInsurance);
    }
  }, [selectedAddons, dispatch, onAddonChange, isRecurringAddonsAllowed]);

  return (
    <>
      <SubTitle>Optional add-ons</SubTitle>

      <Items>
        {addonsToShow.map((addon) => {
          const selected = Boolean(selectedAddons?.find((x) => x.id === addon.id));
          const isItem = isItemInsurance(addon.value);
          const isSports = isSportsInsurance(addon.value);
          return (
            <AddonCard
              key={addon.id}
              addon={addon}
              selected={selected}
              onClick={() => onAddonChange(addon)}
              disabled={isItem && isLessThanMonth}
              subscriptionOnly={!isRecurringAddonsAllowed && (isItem || isSports)}
            />
          );
        })}
      </Items>
    </>
  );
};

Addons.propTypes = {
  showUSAddon: PropTypes.bool,
  numberOfDays: PropTypes.number.isRequired,
  selectedAddons: PropTypes.arrayOf(PropTypes.object),
  onAddonChange: PropTypes.func.isRequired,
  isFixed: PropTypes.bool.isRequired
};

export default Addons;
